import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteContaCaixaCadastro } from '../service';
import {
  DELETE_CONTA_CAIXA_CADASTRO,
  DELETE_CONTA_CAIXA_CADASTRO_PENDING,
  DELETE_CONTA_CAIXA_CADASTRO_SUCCESS,
  DELETE_CONTA_CAIXA_CADASTRO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteContaCaixaCadastro(action) {
  yield put({ type: DELETE_CONTA_CAIXA_CADASTRO_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.CADASTRO_CONTA_CAIXA_EXCLUIR);

  try {
    const a = yield call(deleteContaCaixaCadastro, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_CONTA_CAIXA_CADASTRO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_CONTA_CAIXA_CADASTRO_FAILURE });

    AlertError('Falha ao excluir o registro! Verifique se a conta não possui vínculo com outra conta gerencial ou em lançamentos no financeiro.');
  }
}

export default function* watchDeleteContaCaixaCadastro() {
  yield takeLatest(DELETE_CONTA_CAIXA_CADASTRO, sagaDeleteContaCaixaCadastro)
}
